import ContactPersonItem   from "../Entities/ContactPersonItem";
import ContactGroupItem    from '../Entities/ContactGroupItem';
import HTTPResponseEntity  from "@/js/Shared/Services/HTTP/Entities/HTTPResponseEntity.js";
import HTTPService         from "@/js/Shared/Services/HTTP/HTTPService.js";
import SAPOMailConfig      from "@/SAPOMailConfig";

export {ContactsHTTPService as default};

/**
* Contacts HTTP Service
*
* Fetches contacts data from the backend server
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class ContactsHTTPService {
  /**
   * Contacts Enpoint
   *
   * @public
   *
   * @type {string}
   *
   * @since 7.0.0
   */
  endpoints = SAPOMailConfig.client.endpoints.contacts;

  /**
   * Calls the backend api to retrive a list of all contacts
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Promise<Boolean>}
   */
  async fetchList() {
    let data  = {
      all         : 1,
      source      : 'localsql',
      lastUpdate  : null,
    }

    return await HTTPService.post(this.endpoints.api + '/contactsSearchAPIv2', data, 'fetch_contacts');
  }

  /**
   * Calls the backend api to retrive a list of all contacts
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Promise<Boolean>}
   */
  async fetchFavourites() {
    return await HTTPService.post(this.endpoints.api + '/getFavouriteContacts', {}, 'fetch_favourites_contacts');
  }

  /**
   * Calls the backend api to add a new contact of type person
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {ContactPersonItem} person contact person entity
   *
   * @return {Promise<HTTPResponseEntity>}
   */
  async savePerson(person) {
    let endpoint = (person.id && person.temporary !== true) ? 'updatePerson' : 'addPerson';

    let request = {
      id          : person.id,
      lastname    : person.name,
      email       : person.email,
      cellPhone   : person.mobile_phone,
      homeStreet  : person.home_address,
      birthday    : person.birth_date,
      notes       : person.notes,
      company     : person.company,
    }

    return await HTTPService.post(
      this.endpoints.turba + '/' + endpoint,
      request,
    );
  }

  /**
   * Calls the backend api to add a new contact of type group
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {ContactGroupItem} group contact group entity
   *
   * @return {Promise<HTTPResponseEntity>}
   */
  async saveGroup(group) {
    let endpoint = group.id ? 'updateGroup' : 'addGroup';
    let request = {
      id          : group.id,
      lastname    : group.name,
    }

    return await HTTPService.post(
      this.endpoints.turba + '/' + endpoint,
      request,
    );
  }

  /**
    * Calls the backend api to deletes all given contacts
    *
    * @public
    *
    * @since 7.0.0
    *
    * @param {Array<String>} contacts contacts ids to be deleted
    *
    * @return {Promise<HTTPResponseEntity>}
    */
  async contactsDelete(contacts) {
    let request = {
      ids : JSON.stringify(contacts),
    }

    return await HTTPService.post(
      this.endpoints.turba + '/deleteContacts',
      request,
    );
  }

 /**
  * Calls the backend api to add Persons to a group
  *
  * @public
  *
  * @since 7.0.0
  *
  * @param {Array<String>} persons persons ids to be deleted
  *
  * @return {Promise.<HTTPResponseEntity>}
  */
  async addPersonsToGroup(group_id, persons) {
    let request = {
      group   : group_id,
      persons : JSON.stringify(persons),
    }

    return await HTTPService.post(
      this.endpoints.turba + '/addToGroup',
      request,
    );
  }

 /**
  * Calls the backend api to remove Persons from a group
  *
  * @public
  *
  * @since 7.0.0
  *
  * @param {Array<String>} persons persons ids to be deleted
  *
  * @return {Promise.<HTTPResponseEntity>}
  */
  async removePersonsFromGroup(group_id, persons) {
    let request = {
      group   : group_id,
      persons : JSON.stringify(persons),
    }

    return await HTTPService.post(
      this.endpoints.turba + '/removeFromGroup',
      request,
    );
  }

  /**
   * Calls the backend api to save Persons from contact file
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Object} contacts
   * @returns Promise operation result
   */
  async importContacts(contacts) {
    let request = [];

    contacts.forEach(person => {
      request.push({
        id          : person.id,
        lastname    : person.name,
        email       : person.email,
        cellPhone   : person.mobile_phone,
        homeStreet  : person.home_address,
        birthday    : person.birth_date,
        notes       : person.notes,
        company     : person.company,
      });
    });

    return await HTTPService.post(
      this.endpoints.turba + "/importContacts",
      request,
    );
  }
}